import {
  Autocomplete,
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  Select,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MenuItem from "@mui/material/MenuItem";
import MDTypography from "components/MDTypography";
import React from "react";

function TemplateInfo({ formData, colors, colorsLoading }) {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const { values, errors, touched, setFieldValue } = formData;
  const {
    name: nameV,
    color: colorV,
    description: descriptionV,
    visiblity: visiblityV,
  } = values.info;
  return (
    <MDBox>
      <MDBox>
        <Grid container spacing={3} p={1}>
          <Grid item xs={12} sm={12}>
            <MDBox>
              <MDTypography variant="h5" fontWeight="bold">
                Template Info
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6}>
            <MDInput
              variant="standard"
              label="Template Name"
              value={nameV}
              name="template-name"
              placeholder="Template Name"
              fullWidth
              error={touched?.info?.name && Boolean(errors?.info?.name)}
              helperText={touched?.info?.name && errors?.info?.name}
              onChange={(event) => setFieldValue("info.name", event.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel id="color-label">Color</InputLabel>
              <Select
                fullWidth
                sx={{ height: "30px" }}
                labelId="demo-multiple-chip-label"
                id="color"
                value={colorV || ""}
                onChange={(_) => {
                  setFieldValue("info.color", _?.target?.value);
                }}
                variant="standard"
                endAdornment={colorsLoading ? <CircularProgress color="inherit" size={20} /> : null}
                renderValue={(selected) => (
                  <MDBox
                    sx={{
                      background: selected,
                      height: "20px",
                      width: "20px",
                      borderRadius: "50%",
                      margin: "5px 0px",
                    }}
                  />
                )}
                MenuProps={MenuProps}
              >
                {colors.map((name) => (
                  <MenuItem key={name} value={name}>
                    <MDBox
                      sx={{
                        background: name,
                        height: "20px",
                        width: "20px",
                        borderRadius: "50%",
                        margin: "5px",
                      }}
                    />
                  </MenuItem>
                ))}
              </Select>
              {touched?.info?.color && Boolean(errors?.info?.color) && (
                <FormHelperText>{touched?.info?.color && errors?.info?.color}</FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <MDInput
              variant="standard"
              label="Description"
              value={descriptionV}
              name="description"
              placeholder="Description"
              error={touched?.info?.description && Boolean(errors?.info?.description)}
              helperText={touched?.info?.description && errors?.info?.description}
              onChange={(event) => setFieldValue("info.description", event.target.value)}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              fullWidth
              id="visibility"
              disableClearable
              options={["Private", "Public"]}
              value={visiblityV}
              onChange={(_, value) => setFieldValue("info.visiblity", value)}
              renderInput={(params) => (
                <MDInput
                  {...params}
                  variant="standard"
                  placeholder="Visibility"
                  label="Visibility"
                  error={touched?.info?.visiblity && Boolean(errors?.info?.visiblity)}
                  helperText={touched?.info?.visiblity && errors?.info?.visiblity}
                />
              )}
            />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default TemplateInfo;
